import {ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ListControlValueAccessor} from "../list-control-value-accessor";
import {ListService} from "../../list.service";
import {_find, uuid} from "../../ccl-util";

@Component({
    selector: 'ccl-radios',
    templateUrl: './radios.component.html',
    styleUrls: ['./radios.component.css'],
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: RadiosComponent, multi: true}]
})
export class RadiosComponent extends ListControlValueAccessor implements OnInit, OnChanges {
    radioName = '';// radio çname

    constructor(listService: ListService, cdr: ChangeDetectorRef) {
        super(listService, cdr);
        this.radioName = uuid('ccl-radios');
    }

    // å¤é¨ Control å¼åçååæ¶ï¼å°å¼è®¾ç½®ç» raidos
    writeValue(value: any): void {
        let noChange = true;
        let _value = value;
        if (value !== null && value !== undefined && value !== '') {
            _value = String(value);
            noChange = value === _value;
        } else {
            _value = null;
        }

        this.value = _value;

        this.changeValue(_value, noChange);
    }

    // å½raidosç»ä»¶çå¼åçååï¼å°å¼æ¨éå° Control
    changeValue(value, noChange?) {
        const el = _find(this.dataList, 'value', value) || {};

        this.valueNameChange.emit(el.label || null);
        this.sourceValueChange.emit(el._source || null);

        if (!noChange) {
            this.onChange && this.onChange(value);
        }
        if (noChange === undefined) {
            this.onTouched && this.onTouched();
        }
    }

    ngOnInit() {
        this.initNgOnChanges = true;
        if (this.invokeService) {
            this.loadInvokeServiceData();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (this.initNgOnChanges) {
            // å¨è°ç¨ç¨æ·æ¥å£æ¶ï¼è¥åç°åæ°ååï¼åéæ°è§¦åè°ç¨
            if (changes.invokeServiceParam && this.invokeService) {
                this.loadInvokeServiceData();
            }
        }
    }

}
